import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M12.75 16H16m0 0h3.25M16 16v-3.25M16 16v3.25M6.75 3.75h-3a2 2 0 0 0-2 2v3m5-5h6.5m-6.5 0v-2m0 2v1.5m6.5-1.5h3a2 2 0 0 1 2 2v3H1.75m11.5-5v-2m0 2v1.5m-11.5 3.5v7.5a2 2 0 0 0 2 2h5"
	})]
});
const ForwardRef = forwardRef(SvgCalendarPlus);
export { ForwardRef as ReactComponent };
